import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OstvareniSatiService {
  constructor(private _http: HttpClient) {}

  dohvatiOstvareneSate(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'djelatnik_sihterica', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveLinije(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_linije', a)
      .pipe(map((res: any) => res));
  }
}
